


















import { Vue, Component, State, Prop } from 'nuxt-property-decorator'

@Component
export default class SearchPageHeaderBanner extends Vue {
  @State klook!: Data.Klook
  @Prop() cityName!: string
  @Prop() title!: string
  @Prop() subtitle!: string

  get subTitle() {
    if (this.subtitle) {
      return this.subtitle
    }

    return this.cityName
      ? this.$t('16735', { destination: this.cityName })
      : this.$t('16742')
  }
}
